"use strict";

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Fields, System } from "Constants/objects";

var GroupsBuilder =
/*#__PURE__*/
function () {
  /**
   * @param {Array} groups
   * @param {FormEditStore} formEdit
   */
  function GroupsBuilder(groups, formEdit) {
    _classCallCheck(this, GroupsBuilder);

    _defineProperty(this, "_groups", []);

    _defineProperty(this, "formEdit", null);

    this._groups = groups;
    this._formEdit = formEdit;
  }

  _createClass(GroupsBuilder, [{
    key: "setGroupTemplate",
    value: function setGroupTemplate(group) {
      var _System$GROUP_TYPE = System.GROUP_TYPE,
          PANEL = _System$GROUP_TYPE.PANEL,
          TAB_PANEL = _System$GROUP_TYPE.TAB_PANEL,
          TAB = _System$GROUP_TYPE.TAB,
          ACCORDION = _System$GROUP_TYPE.ACCORDION;
      var groupItems = group['items'] ? group['items'] : []; // подсчет количестка колонок в горизонтальных группах

      if (group[Fields.Orientation] === System.FORM_ORIENTATION.VERTICAL) {
        group['colCount'] = group['items'].length;

        var widthClass = function () {
          //это значит что мы делим для форм-таблиц пространство https://teamtrack.macc.com.ua/view.php?id=59872
          //человек, который читает это, знай, мне правда очень стыдно за этот иф но я его дом труба шатал
          if (group['items'] && group['items'].every(function (item) {
            var cssClass = Array.isArray(item.items) && item['items'].length && item['items'][0].cssClass;
            return !!(typeof cssClass === 'string' && cssClass.match('detail-form'));
          })) {
            switch (group['items'].length) {
              case 2:
                return 'maxWidth -width50';

              case 3:
                return 'maxWidth -width33';

              case 4:
                return 'maxWidth -width25';

              case 5:
                return 'maxWidth -width20';

              default:
                return '';
            }
          }
        }();

        if (group.cssClass) {
          group.cssClass += " ".concat(widthClass);
        } else {
          group.cssClass = widthClass;
        }
      }

      switch (group[Fields.GroupType]) {
        case PANEL:
          return groupItems;

        case TAB_PANEL:
          return this.createTabPanelGroupsDataGroup(group);

        case TAB:
          return groupItems;

        case ACCORDION:
          return this.createCollapsibleGroup(group);
      }
    }
  }, {
    key: "createTabPanelGroupsDataGroup",
    value: function createTabPanelGroupsDataGroup(group) {
      var _this = this;

      var tabPanelSettings = [{
        itemType: 'tabbed',
        animationEnabled: true,
        tabPanelOptions: {
          animationEnabled: true,
          deferRendering: false,
          noDataText: '',
          onSelectionChanged: function onSelectionChanged() {
            if (_this._formEdit.popupInst && _this._formEdit.popupInst.data().hasOwnProperty('dxPopup')) $(_this._formEdit.popupInst).dxPopup('repaint');
          }
        },
        tabs: []
      }];

      _.each(group['items'], function (item) {
        if (item.IsVisible) {
          tabPanelSettings[0]['tabs'].push({
            title: item[Fields.Title] || item['caption'],
            items: item['items']
          });
        }
      });

      group['items'] = tabPanelSettings; // delete group['caption'];

      delete group['Orientation'];
      delete group['colCount'];
      return group;
    }
  }, {
    key: "createCollapsibleGroup",
    value: function createCollapsibleGroup(group) {
      var _this2 = this;

      var title = group['caption'];

      group['template'] = function (data, element) {
        var dataForAccordion = [{
          title: group['caption']
        }];
        $('<div/>').dxAccordion({
          collapsible: true,
          dataSource: dataForAccordion,
          selectedIndex: group[Fields.IsCollapsed] ? -1 : 0,
          elementAttr: {
            id: 'form-edit-accordion-' + group[Fields.ID]
          },
          itemTitleTemplate: function itemTitleTemplate(itemData, itemIndex, itemElement) {
            $(itemElement).text(title);
          },
          onContentReady: function onContentReady(_ref) {
            var element = _ref.element;
            $(element).find('.dx-accordion-item').css('min-height', '42px');
          },
          onSelectionChanged: function onSelectionChanged() {
            if (_this2._formEdit.scrollView) {
              setTimeout(function () {
                $(_this2._formEdit.scrollView).dxScrollView('update');
              }, 300);
            }
          },
          itemTemplate: function itemTemplate(itemData, itemIndex, itemElement) {
            var $insideForm = $('<div/>').dxForm({
              colCount: group['colCount'],
              items: group['items'],
              elementAttr: {
                id: 'form-edit-inside-' + group[Fields.ID]
              }
            });
            $insideForm.appendTo(itemElement);

            if (Array.isArray(_this2._formEdit.insideFormInstances)) {
              _this2._formEdit.insideFormInstances.push($insideForm.dxForm('instance'));
            } else {
              _this2._formEdit.insideFormInstances = [$insideForm.dxForm('instance')];
            }
          }
        }).appendTo(element);
      };

      delete group['caption'];
      return group;
    }
  }, {
    key: "build",
    value: function build() {
      var _this3 = this;

      var obj;
      var groupsData = this._groups.length ? _toConsumableArray(this._groups) : []; // группируем колонки по ParentGroupID

      var groups = _.groupBy(groupsData, function (item) {
        return item[Fields.ParentGroupID];
      }); // копируем так же поля которые сейчас находяться в группах в обьект groups под соответсвующий ключ
      // каждое поля вставляем в отдельную группу для выравнивания и сортируем их


      _.each(groupsData, function (item) {
        item['name'] = "group_".concat(item[Fields.ID]);
        var GROUP_CLASS = "fe-group-id_".concat(item[Fields.ID]);

        if (item['cssClass']) {
          item['cssClass'] += ' ' + GROUP_CLASS;
        } else {
          item['cssClass'] = GROUP_CLASS;
        }

        if (groups[item[Fields.ID]] != null) {
          _.each(item['items'], function (arr) {
            obj = {
              'Order': arr[Fields.Order],
              'itemType': 'group',
              'cssClass': 'form-no-padding',
              'items': [arr]
            };
            groups[item[Fields.ID]].push(obj);
          });

          groups[item[Fields.ID]] = _.sortBy(groups[item[Fields.ID]], Fields.Order);
        }
      }); // создаем массив групп из исходных данных и записываем сгруппированные группы в группы


      groupsData = _.map(groupsData, function (group) {
        group['items'] = !groups[group[Fields.ID]] ? group['items'] : _toConsumableArray(groups[group[Fields.ID]]);
        return group;
      }); // проверяем необходимый шаблон для группы (табы, акордеоны...)

      _.each(groupsData, function (item) {
        _this3.setGroupTemplate(item);
      }); // группируем колонки по ParentGroupID


      groupsData = _.groupBy(groupsData, function (item) {
        return item[Fields.ParentGroupID];
      });
      groupsData = _toConsumableArray(groupsData['null']); // записываем все группы у которых нет родителя

      return groupsData;
    }
  }]);

  return GroupsBuilder;
}();

export { GroupsBuilder as default };